export const SIMULATION_DURATION_MIN = 1;
export const SIMULATION_DURATION_MAX = 24;
export const FLOW_MIN = 1;

export const IN_PROGRESS_STATUSES = ['SCHEDULED', 'RUNNING', 'PREPARING'];

enum simulationEditErrorCode {
  NAME_TOO_SHORT = 'NAME_TOO_SHORT',
}

export const SIMULATION_EDIT_ERROR = {
  [simulationEditErrorCode.NAME_TOO_SHORT]: {
    code: simulationEditErrorCode.NAME_TOO_SHORT,
    i18nMessageKey: 'errors:simulation.edit.run_name.required',
  },
};
